import React from "react";

import * as SC from "./CreditModal.styled";

const LoadingView = () => (
  <SC.ModalContentWrapper>
    <center
      className="blinking"
      style={{
        fontSize: "20px",
        width: "100%",
        opacity: 0.5,
        height: "500px",
        lineHeight: "500px"
      }}
    >
      Processing Payment...
    </center>
  </SC.ModalContentWrapper>
);

export default LoadingView;
